import { ReactNode } from "react";

interface HeroEyebrowProps {
  children: ReactNode;
  icon?: ReactNode;
  className?: string;
}

const HeroEyebrow = ({ children, icon, className = "" }: HeroEyebrowProps) => {
  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full border-2 border-primary bg-background px-4 py-2 shadow-xl shadow-charcoal/40 ${className}`.trim()}
    >
      {icon ? <span className="text-primary">{icon}</span> : null}
      <span className="text-xs sm:text-sm font-bold uppercase tracking-wider text-primary">
        {children}
      </span>
    </span>
  );
};

export default HeroEyebrow;